/* eslint-disable consistent-return */
import FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import FormHelperText from "@material-ui/core/esm/FormHelperText";
import Radio from "@material-ui/core/esm/Radio";
import RadioGroup from "@material-ui/core/esm/RadioGroup";
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { VehicleSize } from 'api';
import { FormElement } from 'components/Form';
import { classificationFieldName } from '../Classification/Classification';

// const REGULAR_CLASSES = [
//   'M1',
//   'M1G',
//   'M2',
//   'M2G',
//   'M3',
//   'M3G',
//   'N1',
//   'N1G',
//   'N2',
//   'N2G',
//   'N3',
//   'N3G',
//   'L1E',
//   'L2E',
//   'L3e',
//   'L4E',
//   'L5e',
//   'L6e',
//   'L7E'
// ];

function Size() {
  const {
    t
  } = useTranslation();
  const {
    control,
    errors,
    getValues
  } = useFormContext();
  return /*#__PURE__*/React.createElement(FormElement, {
    title: t('vehicles.size')
  }, /*#__PURE__*/React.createElement(Controller, {
    rules: {
      validate: {
        classM1(value) {
          const classification = getValues(classificationFieldName);
          const isMobileHome = getValues('isMobileHome');
          if ((classification === 'M1' || classification === 'M1G') && !isMobileHome && value !== VehicleSize.Regular) return t('error.vehicles.m1');
        },
        classN1(value) {
          const classification = getValues(classificationFieldName);
          if ((classification === 'N1' || classification === 'N1G') && value !== VehicleSize.Regular) return t('error.vehicles.n1');
        },
        classN2(value) {
          const classification = getValues(classificationFieldName);
          if ((classification === 'N2' || classification === 'N2G') && value !== VehicleSize.Heavy) return t('error.vehicles.n2');
        },
        classN3(value) {
          const classification = getValues(classificationFieldName);
          if ((classification === 'N3' || classification === 'N3G') && value !== VehicleSize.Heavy) return t('error.vehicles.n3');
        }
        // heavy(value) {
        //   // TODO: check if this rule really makes sense
        //   if (
        //     !REGULAR_CLASSES.includes(getValues(classificationFieldName)) &&
        //     value === VehicleSize.Regular
        //   )
        //     return t('error.vehicles.heavy') as string;
        // }
      }
    },
    control: control,
    defaultValue: VehicleSize.Regular,
    name: "size",
    as: /*#__PURE__*/React.createElement(RadioGroup, {
      "aria-label": "select size option",
      defaultValue: VehicleSize.Regular
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      label: t('vehicles.size_choice.under'),
      value: VehicleSize.Regular,
      control: /*#__PURE__*/React.createElement(Radio, null)
    }), /*#__PURE__*/React.createElement(FormControlLabel, {
      label: t('vehicles.size_choice.over'),
      value: VehicleSize.Heavy,
      control: /*#__PURE__*/React.createElement(Radio, null)
    }))
  }), errors.size && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.size.message));
}
export default Size;